import React from 'react';
import * as PropTypes from 'prop-types';
import { CommentRow } from 'components/video-box/video-comments/fragments/comment-row';

/**
 * @param {[]} comments
 * @param {Function} onDelete
 * @param {number} userId
 * @return {*}
 * @constructor
 */
export const CommentsList = ({ comments, onDelete, userId }) => (
  <div className="ct-comments-list" data-e2e="commentsList">
    {comments &&
      comments.map((comment, index) => (
        <CommentRow
          comment={comment}
          onDelete={onDelete}
          isOwner={!!(userId && userId === comment.user.id)}
          isNew={index === 0}
          key={`comment-${comment.id}`}
        />
      ))}
  </div>
);

CommentsList.propTypes = {
  comments: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
  userId: PropTypes.number,
};
